import { InfoIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  Spacer,
  Stack,
  Text,
  Tooltip,
  useToast,
} from '@chakra-ui/react';
import { navigate } from '@reach/router';
import { Auth } from 'aws-amplify';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { signInPage } from '../../../copy';
import { setUser } from '../../../utils/auth';
import getFormErrorFocus from '../../common/FormikOnError';
import awsconfig from '../../../aws-exports';
import * as cognito from 'amazon-cognito-identity-js';

const { emailId, passwordDesc, signup, forgotPassword, login } = signInPage;

const SigninFormWithEmail = ({
  initUser,
  switchToSignUp,
  switchToForgotPassword,
}) => {
  const [passwordSecure, setPasswordSecure] = useState(false);
  const toast = useToast();
  const [loginLoading, setLoginLoading] = useState(false);

  const getCognitoUser = async (username) => {
    const poolData = {
      UserPoolId: awsconfig.aws_user_pools_id, // your user pool id here
      ClientId: awsconfig.aws_user_pools_web_client_id, // your app client id here
    };
    const userPool = new cognito.CognitoUserPool(poolData);
    const userData = {
      Username: username, // your username here
      Pool: userPool,
    };

    return new cognito.CognitoUser(userData);
  };

  const signIn = async ({ username, password }) => {
    try {
      setLoginLoading(true);
      const cognitoUser = await getCognitoUser(username);
      const authenticationDetails = new cognito.AuthenticationDetails({
        Username: username,
        Password: password,
      });
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: async function (result) {
          const cognitoUserObj = await Auth.currentAuthenticatedUser();
          setUser(cognitoUserObj);
          await initUser();

          toast({
            title: 'Success',
            description: '',
          });
          navigate('/');
          setLoginLoading(false);
        },
        onFailure: async function (error) {
          setLoginLoading(false);
          toast({
            title: 'Error',
            description:
              error?.message || 'Something went wrong. Please try again',
            status: 'error',
          });
        },
      });
      /* await Auth.signIn({
        username,
        password,
      }); */
    } catch (error) {
      setLoginLoading(false);
      if (error.code === 'UserNotFoundException') {
        // setIsSigningIn(false);
      }
      toast({
        title: 'Error',
        description: error?.message || 'Something went wrong. Please try again',
        status: 'error',
      });
    }
  };

  const formik = useFormik({
    initialValues: { email: '', password: '' },
    validationSchema: Yup.object({
      email: Yup.string().email('Invalid email').required('Please enter email'),
      password: Yup.string().required('Please enter password'),
    }),
    onSubmit: (values) => {
      signIn({
        username: values.email,
        password: values.password,
      });
    },
  });

  const { values, errors, handleBlur, handleSubmit, setFieldValue, touched } =
    formik;

  useEffect(() => {
    getFormErrorFocus(formik);
  }, [formik.isSubmitting]);

  return (
    <Stack>
      <Box>
        <form onSubmit={handleSubmit}>
          <Stack spacing={4}>
            <FormControl
              id="email"
              isInvalid={!!errors.email && !!touched.email}
            >
              <FormLabel display="inline">
                {emailId}{' '}
                <Text as="span" color="brand.red">
                  *
                </Text>
              </FormLabel>
              <Tooltip
                hasArrow
                label="Use only verifyied Email Id"
                bg="brand.red"
              >
                <InfoIcon fontSize="10px" color="brand.red" />
              </Tooltip>
              <Input
                // {...inputTextStyleProps}
                name="hidden"
                type="text"
                onBlur={handleBlur}
                value={values.email}
                onChange={(e) => {
                  setFieldValue('email', e.target.value);
                }}
                placeholder="Please Enter EmailId"
              />
              <FormErrorMessage>{errors.email}</FormErrorMessage>
            </FormControl>
            <FormControl
              id="password"
              isInvalid={!!errors.password && !!touched.password}
            >
              <FormLabel>
                {passwordDesc}
                <Text as="span" color="brand.red">
                  *
                </Text>
              </FormLabel>
              <InputGroup>
                <Input
                  // {...inputTextStyleProps}
                  autoComplete="new-password"
                  type={!passwordSecure ? 'password' : 'text'}
                  onBlur={handleBlur}
                  value={values.password}
                  onChange={(e) => {
                    setFieldValue('password', e.target.value);
                  }}
                  placeholder="Please Enter Password"
                />
                <InputRightElement>
                  <Button
                    tabIndex="-1"
                    color="brand.black"
                    variant="link"
                    onClick={() => {
                      setPasswordSecure(!passwordSecure);
                    }}
                  >
                    {passwordSecure ? <FaEye /> : <FaEyeSlash />}
                  </Button>
                </InputRightElement>
              </InputGroup>
              <FormErrorMessage>{errors.password}</FormErrorMessage>
            </FormControl>

            <Stack spacing={4}>
              <Stack align="flex-end" justify="space-between">
                <Button
                  color="brand.red"
                  variant="link"
                  onClick={() => switchToForgotPassword()}
                >
                  {forgotPassword}
                </Button>
              </Stack>
              <Flex pb="8">
                <Box>
                  <Button
                    variant="cancel-button"
                    borderColor="brand.red"
                    color="brand.red"
                    onClick={() => switchToSignUp()}
                  >
                    {signup}
                  </Button>
                </Box>
                <Spacer />
                <Box>
                  <Button
                    isLoading={loginLoading}
                    type="submit"
                    _hover={{ background: 'brand.red' }}
                  >
                    {login}
                  </Button>
                </Box>
              </Flex>
            </Stack>
          </Stack>
        </form>
      </Box>
    </Stack>
  );
};

const stateMapper = () => ({});

const dispatchMapper = (dispatch) => ({
  initUser: dispatch.auth.fetchAndSetUser,
});

export default connect(stateMapper, dispatchMapper)(SigninFormWithEmail);
